export interface ClientUrlParams {
  mode: string | null;
  configID: string | null;
  componentID: string | null;
}

export function getUrlParams(): ClientUrlParams {
  const urlParams = new URL(document.location.href).searchParams;
  return {
    mode: urlParams.get('mode'),
    configID: urlParams.get('config'),
    componentID: urlParams.get('componentID')
  };
}

export function formatConfigTitle(configID: string): string {
  return configID.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

